var _rect, _g, _rect2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVuv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2757_5916",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2757_5916)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H23V23H0V0Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V7.66667H23V0H0Z",
    fill: "#C51918"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 15.3335V23.0002H23V15.3335H0Z",
    fill: "#5EAA22"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 -1.9165L11.9813 11.5002L0 24.9168V-1.9165Z",
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-7-outside-1_2757_5916",
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: -6.21533,
    width: 25,
    height: 35,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: -1,
    y: -6.21533,
    width: 25,
    height: 35
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 -3.21533L12.5122 9.58316H23V13.4165H12.3405L0 25.6942V21.4092L10.0625 11.4998L0 1.47039V-3.21533Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 -3.21533L12.5122 9.58316H23V13.4165H12.3405L0 25.6942V21.4092L10.0625 11.4998L0 1.47039V-3.21533Z",
    fill: "#FFD018"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5122 9.58316L11.7972 10.2822L12.0914 10.5832H12.5122V9.58316ZM0 -3.21533L0.715059 -3.9144L-1 -5.6687V-3.21533H0ZM23 9.58316H24V8.58316H23V9.58316ZM23 13.4165V14.4165H24V13.4165H23ZM12.3405 13.4165V12.4165H11.9278L11.6352 12.7076L12.3405 13.4165ZM0 25.6942H-1V28.0997L0.705301 26.4031L0 25.6942ZM0 21.4092L-0.701664 20.6967L-1 20.9905V21.4092H0ZM10.0625 11.4998L10.7642 12.2123L11.4833 11.5041L10.7684 10.7916L10.0625 11.4998ZM0 1.47039H-1V1.88557L-0.705942 2.17866L0 1.47039ZM13.2273 8.88409L0.715059 -3.9144L-0.715059 -2.51627L11.7972 10.2822L13.2273 8.88409ZM23 8.58316H12.5122V10.5832H23V8.58316ZM24 13.4165V9.58316H22V13.4165H24ZM12.3405 14.4165H23V12.4165H12.3405V14.4165ZM0.705301 26.4031L13.0458 14.1254L11.6352 12.7076L-0.705301 24.9853L0.705301 26.4031ZM-1 21.4092V25.6942H1V21.4092H-1ZM9.36084 10.7873L-0.701664 20.6967L0.701664 22.1217L10.7642 12.2123L9.36084 10.7873ZM-0.705942 2.17866L9.35656 12.2081L10.7684 10.7916L0.705942 0.762123L-0.705942 2.17866ZM-1 -3.21533V1.47039H1V-3.21533H-1Z",
    fill: "#272727",
    mask: "url(#path-7-outside-1_2757_5916)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.50297 16.0695L3.50441 14.555C4.51664 14.2573 5.1872 13.87 5.5136 13.4042C6.31733 12.0835 5.78304 8.98916 4.1318 9.0094C3.31373 9.0094 2.46777 9.52918 2.46777 10.7525C2.46777 12.2719 2.70227 12.9214 3.50441 12.9214C4.30154 12.9214 4.59379 12.9782 5.11887 12.024L5.68868 12.2588C5.12601 13.2813 4.36755 14.089 3.50297 14.089C2.07873 14.089 1.30367 12.6572 1.30367 11.0013C1.30367 8.95709 2.54831 7.52539 4.04902 7.52539C5.16877 7.52539 6.93987 9.35409 6.93987 11.0013C6.93987 12.6485 6.93987 13.4042 5.96872 14.555C5.57756 15.0185 4.60836 15.8463 3.50297 16.0695Z",
    fill: "#FFD018"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.58759 9.46844C3.53276 9.44913 3.47658 9.49275 3.4621 9.56585L3.42285 9.76406C3.42088 9.76066 3.41891 9.75726 3.41694 9.75386C3.38228 9.69402 3.3178 9.68298 3.27292 9.72919C3.22804 9.77541 3.21975 9.86138 3.25441 9.92122C3.2782 9.96229 3.30167 10.0029 3.32483 10.043L3.2065 10.1887C3.16484 10.24 3.16225 10.3266 3.20072 10.3821C3.23919 10.4377 3.30415 10.4411 3.34581 10.3898L3.45037 10.2611C3.5128 10.3699 3.57262 10.4747 3.62978 10.5754L3.43295 10.7163C3.38298 10.752 3.36422 10.835 3.39105 10.9016C3.41787 10.9682 3.48012 10.9933 3.53008 10.9575L3.75489 10.7966C3.80882 10.8924 3.85996 10.9838 3.90824 11.0706L3.6383 11.2639C3.58834 11.2996 3.56958 11.3826 3.5964 11.4493C3.62323 11.5159 3.68548 11.5409 3.73544 11.5051L4.03123 11.2934C4.1099 11.4369 4.17886 11.5649 4.23775 11.6764L4.04902 11.8115C3.99905 11.8473 3.9803 11.9303 4.00712 11.9969C4.03394 12.0635 4.09619 12.0885 4.14615 12.0527L4.35503 11.9032C4.44191 12.0758 4.48689 12.1794 4.48689 12.2066C4.48689 12.2822 4.53286 12.3435 4.58957 12.3435C4.64628 12.3435 4.69225 12.2822 4.69225 12.2066C4.69225 12.1373 4.63819 11.9916 4.52521 11.758C4.52684 11.7542 4.52835 11.7503 4.52971 11.7463L4.68165 11.3003C4.7051 11.2314 4.68225 11.1503 4.63062 11.119C4.57899 11.0877 4.51812 11.1182 4.49467 11.187L4.39087 11.4918C4.32602 11.3673 4.25033 11.2265 4.16342 11.0683L4.27093 10.7527C4.29438 10.6838 4.27154 10.6027 4.21991 10.5714C4.16827 10.5401 4.10741 10.5706 4.08396 10.6394L4.02368 10.8164C3.99047 10.757 3.95595 10.6956 3.92011 10.6321L4.06558 10.205C4.08903 10.1362 4.06618 10.055 4.01455 10.0238C3.96292 9.99251 3.90205 10.023 3.8786 10.0918L3.77917 10.3837C3.71655 10.2739 3.65051 10.1586 3.58101 10.0379L3.66065 9.63576C3.67513 9.56265 3.64242 9.48774 3.58759 9.46844Z",
    fill: "#FFD018"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.27813 9.46844C4.33296 9.44913 4.38915 9.49275 4.40362 9.56585L4.44288 9.76406C4.44484 9.76066 4.44681 9.75726 4.44878 9.75386C4.48344 9.69402 4.54792 9.68298 4.5928 9.72919C4.63769 9.77541 4.64597 9.86138 4.61131 9.92122C4.58752 9.96229 4.56405 10.0029 4.54089 10.043L4.65922 10.1887C4.70089 10.24 4.70347 10.3266 4.665 10.3821C4.62653 10.4377 4.56157 10.4411 4.51991 10.3898L4.41535 10.2611C4.35292 10.3699 4.2931 10.4747 4.23594 10.5754L4.43278 10.7163C4.48274 10.752 4.5015 10.835 4.47467 10.9016C4.44785 10.9682 4.3856 10.9933 4.33564 10.9575L4.11083 10.7966C4.0569 10.8924 4.00576 10.9838 3.95748 11.0706L4.22742 11.2639C4.27738 11.2996 4.29614 11.3826 4.26932 11.4493C4.24249 11.5159 4.18025 11.5409 4.13028 11.5051L3.83449 11.2934C3.75583 11.4369 3.68686 11.5649 3.62798 11.6764L3.81671 11.8115C3.86667 11.8473 3.88543 11.9303 3.8586 11.9969C3.83178 12.0635 3.76953 12.0885 3.71957 12.0527L3.51069 11.9032C3.42381 12.0758 3.37883 12.1794 3.37883 12.2066C3.37883 12.2822 3.33286 12.3435 3.27615 12.3435C3.21945 12.3435 3.17347 12.2822 3.17347 12.2066C3.17347 12.1373 3.22754 11.9916 3.34051 11.758C3.33888 11.7542 3.33738 11.7503 3.33601 11.7463L3.18407 11.3003C3.16062 11.2314 3.18347 11.1503 3.2351 11.119C3.28673 11.0877 3.3476 11.1182 3.37105 11.187L3.47485 11.4918C3.5397 11.3673 3.61539 11.2265 3.70231 11.0683L3.59479 10.7527C3.57134 10.6838 3.59418 10.6027 3.64582 10.5714C3.69745 10.5401 3.75831 10.5706 3.78176 10.6394L3.84204 10.8164C3.87526 10.757 3.90978 10.6956 3.94561 10.6321L3.80015 10.205C3.7767 10.1362 3.79954 10.055 3.85117 10.0238C3.90281 9.99251 3.96367 10.023 3.98712 10.0918L4.08655 10.3837C4.14917 10.2739 4.21521 10.1586 4.28472 10.0379L4.20507 9.63576C4.19059 9.56265 4.22331 9.48774 4.27813 9.46844Z",
    fill: "#FFD018"
  }))), /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "url(#paint0_linear_2757_5916)",
    style: {
      mixBlendMode: "overlay"
    }
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 22,
    height: 22,
    rx: 11,
    stroke: "black",
    strokeOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2757_5916",
    x1: 11.5,
    y1: 0,
    x2: 11.5,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuv);
export default __webpack_public_path__ + "static/media/VUV.cc48c9b83a6603c4991026144db59075.svg";
export { ForwardRef as ReactComponent };